import { CheckCircle, XCircle } from "@reverb-ui/icons-react";
import { Text, Progress, Flex } from "@reverb-ui/react";
import moment from "moment";

type TCompletionCell = {
  value: number;
  dueDate: Date;
};

export const CompletionCell = ({ value, dueDate }: TCompletionCell) => {
  const momentDueDate = moment(dueDate);
  const momentToday = moment().startOf("day");

  return value >= 100 ? (
    <Flex
      alignItems="center"
      justifyContent="center"
      color="success.500"
      gap={2}
    >
      <CheckCircle color="success.500" />
      <Text fontSize="sm" fontWeight="semibold">
        Achieved!
      </Text>
    </Flex>
  ) : momentDueDate.startOf("day").isBefore(momentToday) ? (
    <Flex
      alignItems="center"
      justifyContent="center"
      color="neutral.500"
      gap={2}
    >
      <XCircle color="neutral.500" />
      <Text fontSize="sm" fontWeight="semibold">
        Not achieved
      </Text>
    </Flex>
  ) : (
    <Flex alignItems="center" justifyContent="space-around">
      <Progress
        color="primary.500"
        width="90px"
        height="8px"
        borderRadius="4px"
        value={value}
      />
      <Text>{value}%</Text>
    </Flex>
  );
};
